import { render, staticRenderFns } from "./UpdateOrganizationNews.vue?vue&type=template&id=8101d7e6"
import script from "./UpdateOrganizationNews.vue?vue&type=script&lang=js"
export * from "./UpdateOrganizationNews.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrganizationNews.vue?vue&type=style&index=0&id=8101d7e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports